export const loadVehicleDayPriceFromFormula = (formula: string) => {
  const hasMultipleCars = formula.includes('(');
  const mainFormula = hasMultipleCars
    ? formula.split('(')[1].slice(0, -1)
    : formula;
  let prices: string[] = [];
  const formulaParts = mainFormula.split('+');
  for (const formulaPart of formulaParts) {
    const [price, nbDays] = formulaPart.split('×');
    for (let i = 0; i < Number(nbDays); i++) {
      prices.push(price.trim());
    }
  }
  prices = prices.filter((price) => price !== '');
  return prices.map((price) => {
    const nbVehicles = formula.split('×')[0].trim();
    return {
      formula: hasMultipleCars ? `${nbVehicles} × ${price}` : price,
      minimumPrice: hasMultipleCars
        ? Number(nbVehicles) * Number(price)
        : Number(price),
    };
  });
};
